"use client";

import { useCustomer } from "@/hooks/useCustomer";
import { getPermalink, __ } from "@/lib/i18n/functions";
import { Locales } from "@/lib/i18n";
import Link from "next/link";
import { getSidebarLinks } from "@/components/templates/Account/components/account-sidebar";
import UserMenu from "@/components/atoms/user-menu/UserMenu";
import { useCheckoutStore } from "@/stores/checkout-store";

type LoginNavbarButtonProps = {
  locale: Locales;
};

const LoginNavbarButton = ({ locale }: LoginNavbarButtonProps) => {
  const { customer } = useCustomer();
  const accountType = useCheckoutStore((state) => state.accountType);

  if (customer === undefined) {
    return <div className="shimmer h-10 w-12 rounded-md" />;
  }

  if (customer === null || customer === undefined) {
    return (
      <Link
        href={getPermalink(locale, "login")}
        className="h-auto cursor-pointer rounded-md bg-[#f4f5f8] p-2.5 transition-all duration-150 ease-in-out hover:scale-[102%] active:scale-[98%]"
      >
        <span className="text-dark-primary font-cabinet-grotesk text-sm font-medium">{__("Log in", locale)}</span>
      </Link>
    );
  }

  const links = getSidebarLinks(locale, accountType || "individual");

  return <UserMenu links={links} defaultOpen={false} dropdownContentAlign="end" className="" locale={locale} />;
};

export default LoginNavbarButton;
